import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageService } from '../../services/manage.service';
import { CommonService } from '../../services';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';

@Component({
  selector: 'confirm-autodesk-switch',
  templateUrl: './confirm-autodesk-switch.component.html',
  styleUrls: ['./confirm-autodesk-switch.component.css']
})
export class ConfirmAutodeskSwitchComponent implements OnInit {

  public result: ApiResponse;

  public msg: string;

  public inProgress = false;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<ConfirmAutodeskSwitchComponent>,
    private manageService: ManageService,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.msg = this.data.text;
  }

  onContinueEvent(): void {
    if (!this.result) {
      this.inProgress = true;
      this.manageService.AutodeskTermSwitch(this.data.term, this.data.list)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: ApiResponse) => {
          this.result = res;
          this.msg = res.responseMessage;
          this.inProgress = false;
        });
      } else {
        this.dialogRef.close(this.result);
      }
  }

  cancelEvent(): void {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
